module.exports = __webpack_public_path__ + "img/no-data.f874e6c1.svg";